module.exports = __webpack_public_path__ + "img/welcome_trade_green.9df8a934.png";